import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { VacationRequestsPopupService } from "projects/shared/src/public-api";
import { OpportunitiesPopupComponent } from "../../modules/opportunities/opportunities-popup/opportunities-popup.component";
import { ToDosPopupComponent } from "../../modules/todos/to-dos-popup/to-dos-popup.component";
import { ProspectsPopupComponent } from "../../modules/business-partners/prospects-popup/prospects-popup.component";
import { tabsModel } from "../models/app.model";
import { SalesOrderPopupComponent } from "../../modules/sales-order/sales-order-popup/sales-order-popup.component";

@Injectable()
export class SalesVacationRequestsPopupService
  extends VacationRequestsPopupService {

  constructor(private dialog: MatDialog) {
    super();
  }

  openOpportunity(id: string = null, tab = 'details'): Observable<unknown> {
    const dialog = this.dialog.open(OpportunitiesPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      autoFocus: false,
      data: {
        id,
        isMaximized: true,
        type: 'indirect',
        tab,
        forcfullyOpenEditActivitesPopupForVacationRequests: true
      }
    });

    return dialog.afterClosed();
  }

  openToDo(id: string): Observable<unknown> {
    const dialogRef = this.dialog.open(ToDosPopupComponent, {
      backdropClass: 'no-backdrop',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        autoFocus: false,
      data: {
        todoId: id,
        isMaximized: true
      }
    });

    return dialogRef.afterClosed();
  }

  openProspect(customerId: string): Observable<unknown> {
    const dialogRef = this.dialog.open(ProspectsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      autoFocus: false,
      data: {
        id: customerId,
        tab: tabsModel.details,
        isMaximized: true
      }
    });

    return dialogRef.afterClosed();
  }

  
  openSalesOrder(id: string) {
      const dialog = this.dialog.open(SalesOrderPopupComponent, {
          backdropClass: 'no-backdrop',
          disableClose: true,
          maxWidth: '100vw',
          maxHeight: '100vh',
          width: '100%',
          height: '100%',
          enterAnimationDuration: '0',
          exitAnimationDuration: '0',
          data: {
            title: '',
            tab: tabsModel.details,
            isMaximized: true,
            id,
          }
      });
      return dialog.afterClosed();
    }
}